import { render } from "./InvestmentValue.vue?vue&type=template&id=c873c440"
import script from "./InvestmentValue.vue?vue&type=script&lang=js"
export * from "./InvestmentValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__